<template>
  <v-form v-model="valid" @submit="login">
    <v-card class="mx-auto pb-3 px-6" max-width="400" elevation="3">
      <v-card-text>
        <v-alert
          v-if="message"
          type="error"
          dense
          color="alert"
          class="text-caption"
        >
          {{ message }}
        </v-alert>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="username"
              hint="Bitte nutzen Sie Ihre RBG-Kennung z.B. bargou"
              persistent-hint
              :rules="[(v) => !!v || 'Nutzername ist erforderlich']"
              label="Nutzername"
              required
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <v-text-field
              v-model="password"
              type="password"
              :rules="[(v) => !!v || 'Passwort ist erforderlich']"
              label="Passwort"
              required
              @keyup="isCapLock"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-btn
            class="white--text"
            type="login"
            block
            color="tertiary"
            depressed
          >
            Login
          </v-btn>
        </v-row>
      </v-card-text>
    </v-card>
  </v-form>
</template>

<!-- TODO: give feedback, when Login credentials are wrong -->

<script>
export default {
  name: "Login",
  data: () => ({
    valid: false,
    username: "",
    password: "",
    message: undefined,
  }),
  methods: {
    login(e) {
      e.preventDefault();
      this.$store
        .dispatch("userLogin", {
          username: this.username,
          password: this.password,
        })
        .then(() => {
          this.$router.push({ name: "tutorials" });
          location.reload();
        })
        .catch((err) => (this.message = err));
    },
    isCapLock(e) {
      if (e.getModifierState("CapsLock")) {
        this.message = "Ihre Feststelltaste ist aktiviert.";
      } else {
        this.message = undefined;
      }
    },
  },
};
</script>
